<template>
    <section v-if="bonus">
        <h1>{{"components.pages.bonus-rules.title" | translate}}</h1>
        <registration v-if="bonus.registration" :bonus="bonus.registration" />
        <deposit v-if="bonus.deposit" :bonus="bonus.deposit" />
        <coupon v-if="bonus.coupon" :bonus="bonus.coupon" />
        <cashback v-if="bonus.cashback" :bonus="bonus.cashback" />
        <mailing v-if="bonus.mailing" />
        <string-content :content-ref="bottomContent" />
        <printer>
            <div class="content">
                <h1>{{"components.pages.bonus-rules.title" | translate}}</h1>
                <registration v-if="bonus.registration" :bonus="bonus.registration" />
                <deposit v-if="bonus.deposit" :bonus="bonus.deposit" />
                <coupon v-if="bonus.coupon" :bonus="bonus.coupon" />
                <cashback v-if="bonus.cashback" :bonus="bonus.cashback" />
                <mailing v-if="bonus.mailing" />
                <string-content :content-ref="bottomContent" />
            </div>
        </printer>
    </section>
</template>
<script>
import Vue from 'vue';

import Registration from './bonus-rules-registration/index.vue';
import Deposit from './bonus-rules-deposit/index.vue';
import Coupon from './bonus-rules-coupon/index.vue';
import Cashback from './bonus-rules-cashback/index.vue';
import Mailing from './bonus-rules-mailing/index.vue';
import pushService from '../../../../../../_common/services/push.service';
import StringContent from '../../../../../../_common/components/content/string-content.js';
import Printer from '../../../common/printer/printer.vue';

export default {
    name: 'bonus-rules',
    components: { Registration, Deposit, Coupon, Cashback, Mailing, StringContent,Printer },
    computed: {
        bonus() {
            let client = Vue.state.client.get();
            return client && client.bonus;
        },
        bottomContent() {
            let client = Vue.state.client.get();
            return client && client.bonus && client.bonus.bottomContentRules;
        }
    },
    methods:{
        goBack() {
            const backPath = Vue.state.route.from.get() || '/';
            this.$router.push(backPath);
        }
    }
};
</script>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules.vue